import withRoot from './modules/withRoot';
// --- Post bootstrap -----
import React from 'react';

function Landing() {
  return (
    <div>
      Landing Page here
    </div>
  );
}

export default Landing
